import script from "./OptimizeSignalAside.vue?vue&type=script&setup=true&lang=ts"
export * from "./OptimizeSignalAside.vue?vue&type=script&setup=true&lang=ts"

import "./OptimizeSignalAside.vue?vue&type=style&index=0&id=0ddfca95&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ddfca95"]])

export default __exports__